
export default {
  name: 'Spinner',
};
